import colors from './colors';

const BTN_SMALL = 30;
const BTN_MEDIUM = 36;
const BTN_LARGE = 40;

const buttonSize = (size) => ({
  minHeight: size,
  minWidth: size,
  height: size,
});

export const components = {
  MuiTypography: {
    styleOverrides: {
      root: ({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
          userSelect: 'none',
        },
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        fontSize: 16
      },
      sizeSmall: {
        ...buttonSize(BTN_SMALL),
        fontSize: 13
      },
      sizeMedium: buttonSize(BTN_MEDIUM),
      sizeLarge: buttonSize(BTN_LARGE),
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-disabled.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[400],
        },
        '&.Mui-disabled .MuiInputAdornment-root, &.Mui-disabled .MuiSvgIcon-root': {
          color: theme.palette.grey[500],
        },
      }),
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        padding: 8
      },
      sizeSmall: buttonSize(BTN_SMALL),
      sizeMedium: buttonSize(BTN_MEDIUM),
      sizeLarge: buttonSize(BTN_LARGE),
    },
    variants: [
      {
        props: { variant: 'filter' },
        style: {
          '&.Mui-selected': {
            backgroundColor: 'currentColor',
            borderColor: 'currentColor !important',
            '&:hover': {
              backgroundColor: 'currentColor',
            },
            '&.Mui-selected *': {
              color: 'white !important',
            },
          },
        },
      },
    ],
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        overflow: 'hidden',
      },
    },
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        margin: 20,
        fontSize: 16,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 32,
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: '1rem',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      message: {
        width: '90%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: 'auto',
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        backgroundColor: '#FFFFFF',
      },
      columnHeaderTitle: { fontWeight: 600 },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: colors.grey[1000],
        fontSize: '0.75rem',
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.grey[700],
      }),
    },
  },
};
